import React, { Component } from "react";
import "./SystemVersion.scss";

import pkgJson from "../../../../package.json";

class SystemVersion extends Component {
    render() {
        return <div className="SystemVersion text-end ms-auto">v{pkgJson.version}</div>;
    }
}

export default SystemVersion;
